import React, { Component } from 'react';
import {
  Button,
  FormGroup,
  FormControl,
  FormLabel,
  Form,
  Container,
  Row,
  Col,
} from 'react-bootstrap';
import Cookies from 'universal-cookie';
import { login, signup } from '../api';
import './../styles/Login.scss';
import Lottie from 'react-lottie';
import animationData from '../lottie/drink.json';
import Logo from '../images/bargoat-app-icon.png';

const cookies = new Cookies();

class Login extends Component<any, any> {
  state = {
    username: '',
    password: '',
  };

  constructor(props: any) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async handleSubmit(event: any, isSignup: any) {
    event.preventDefault();

    const user = {
      username: this.state.username,
      password: this.state.password,
    };

    const cookieOptions = {
      path: '/',
      httpOnly: false,
      maxAge: 60 * 60 * 24 * 7,
    };
    if (isSignup) {
      await signup(user)
        .then((res: any) => {
          window.localStorage.removeItem('selectedDate');
          cookies.set('username', res.data, cookieOptions);
          cookies.set('name', res.data, cookieOptions);
          this.props.history.push('/');
        })
        .catch((err: any) => {
          console.log(err);
          alert(
            'Invalid Input:\nusername must be at least 3 characters\npassword must be at least 6 characters'
          );
        });
    } else {
      await login(user)
        .then((res: any) => {
          window.localStorage.removeItem('selectedDate');
          cookies.set('username', res.username, cookieOptions);
          cookies.set('business_id', res.business_entity_id, cookieOptions);
          cookies.set('tk', res.token, cookieOptions);
          this.props.history.push('/bar/');
        })
        .catch((err: any) => {
          console.log(err);
          alert('Incorrect username and password');
        });
    }
  }

  validateForm() {
    return this.state.username.length > 0 && this.state.password.length > 0;
  }

  handleChange(event: any) {
    this.setState({
      [event.target.id]: event.target.value,
    });
  }

  render() {
    const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: animationData,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
    };
    return (
      <Container fluid>
        <Row>
          <Col lg="6" className="split-left d-flex align-items-center">
            <div className="col-lg-7" id="form-login">
              <h2 className="form-heading">
                SIGN IN TO BARGOAT{' '}
                <img src={Logo} alt="BarGoat" style={{ maxWidth: '36px' }} className="ml-1" />
              </h2>
              <hr className="form-split mt-2 mb-4"></hr>
              <Form>
                <FormGroup controlId="username">
                  <FormLabel className="form-label">Username</FormLabel>
                  <FormControl
                    autoFocus
                    type="text"
                    value={this.state.username}
                    onChange={(e) => this.handleChange(e)}
                    className="login-input"
                    placeholder="Username"
                  />
                </FormGroup>
                <FormGroup controlId="password">
                  <FormLabel className="form-label">Password</FormLabel>
                  <FormLabel className="float-right forgot">
                    <a href="/forgotPassword">Forgot password?</a>
                  </FormLabel>
                  <FormControl
                    value={this.state.password}
                    onChange={(e) => this.handleChange(e)}
                    type="password"
                    className="login-input"
                    placeholder="Password"
                  />
                </FormGroup>
                <Button
                  disabled={!this.validateForm()}
                  type="submit"
                  onClick={(e: any) => this.handleSubmit(e, false)}
                  className="login-btn col-lg-4 mt-2"
                >
                  Sign In
                </Button>{' '}
              </Form>
              <hr className="form-split mt-4 mb-3"></hr>
              <p className="help-text">
                {"Don't have an account? "}
                <a href="/#">Contact sales</a>
              </p>
            </div>
          </Col>
          <Col lg="6" className="split-right d-none d-lg-block">
            <div className="align-items-center" style={{ marginTop: '100px' }}>
              <Lottie options={defaultOptions} height={500} width={500} />
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default Login;
